import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('as-segmented-button')
export class SegmentedButton extends LitElement {
  public static styles = css`
    .segmented-button {
      padding: 0 16px;
      color: #767676;
      border: 1px solid #d9d9d9;
      cursor: pointer;
      margin-right: -1px;
    }

    .segmented-button.active {
      background-color: #d3e6fa;
      color: #000000;
    }

    .segmented-button:not(.active):hover {
      background-color: #b9d7f5;
      border-color: #b9d7f5;
      color: #000000;
    }
  `;

  @property({ type: Boolean })
  public checked = false;

  public render() {
    return html`
      <div class="segmented-button ${this.checked ? 'active' : ''} tabindex="0">
        <slot></slot>
      </div>
    `;
  }
}
